var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconShare01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M3.634 7.415a1.585 1.585 0 1 0 0 3.17 1.585 1.585 0 0 0 0-3.17M.449 9a3.185 3.185 0 1 1 6.37 0 3.185 3.185 0 0 1-6.37 0M14.364 2.05a1.585 1.585 0 1 0 0 3.17 1.585 1.585 0 0 0 0-3.17M11.18 3.635a3.185 3.185 0 1 1 6.369 0 3.185 3.185 0 0 1-6.37 0M14.364 12.78a1.585 1.585 0 1 0 0 3.17 1.585 1.585 0 0 0 0-3.17m-3.184 1.585a3.185 3.185 0 1 1 6.369 0 3.185 3.185 0 0 1-6.37 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12.79 3.9a.8.8 0 0 1-.432 1.046L5.382 7.843a.8.8 0 1 1-.613-1.478l6.975-2.897a.8.8 0 0 1 1.045.432M4.337 10.589a.8.8 0 0 1 1.045-.432l6.976 2.897a.8.8 0 1 1-.614 1.478l-6.975-2.898a.8.8 0 0 1-.432-1.045",
  clipRule: "evenodd"
})));
export default SvgIconShare01;